import { Controller } from "@hotwired/stimulus";
import { addToQueue, getAllQueue, getAttendanceStatus, saveLog } from "../../pwa/offline_queue";
import { showPwaFlash } from "../../pwa/show_pwa_flash";
import { renderBadge, resolveOfflineStatus } from "../../pwa/attendance_badge";

export default class extends Controller {
    async submit(event) {
        const form = this.element
        const mode = form.querySelector('[name="mode"]')?.value

        const checkboxes = document.querySelectorAll(".member-checkbox")
        if (mode !== "individual") {
            checkboxes.forEach(cb => cb.setAttribute("form", form.id))
        } else {
            checkboxes.forEach(cb => cb.removeAttribute("form"))
        }

        if (navigator.onLine) {
            return
        }

        event.preventDefault()

        const formData = new FormData(form)

        const payload = {}

        const type = form.action.includes("clock_out") ? "clock_out" : "clock_in"
        const modeLabel = mode === "individual" ? "個人" : "班一括"

        // Log the action
        const timeStr = new Date().toTimeString().slice(0, 8)
        const actionStr = type === "clock_out" ? "退勤" : "出勤" 
        let logMessage

        if (mode === "individual") {
            const weatherId = formData.get("weather_id")
            if (!weatherId) {
                logMessage = `【${modeLabel}・オフライン】出勤打刻に失敗しました。天気情報が選択されていません。`
                await saveLog(logMessage)
                this.appendLogMessage(logMessage)
                showPwaFlash(logMessage, "error")
                return
            }

            const isValid = await this.validateIndividualStatus(type)
            if (!isValid) return

            logMessage = `【${modeLabel}・オフライン】あなた さんが ${actionStr}：${timeStr} に打刻しました（オフライン記録）`
            showPwaFlash(logMessage, "success")
        } else {
            const workerIds = [...formData.entries()].filter(([key]) => key === 'worker_ids[]')
            const count = workerIds.length
            const weatherId = formData.get("weather_id")
            
            if (!weatherId) {
                logMessage = `【${modeLabel}・オフライン】出勤打刻に失敗しました。天気情報が選択されていません。`
                await saveLog(logMessage)
                this.appendLogMessage(logMessage)
                showPwaFlash(logMessage, "error")
                return
            }

            if (count === 0) {
                logMessage = `【${modeLabel}・オフライン】出勤打刻に失敗しました。班員が選択されていません。`
                await saveLog(logMessage)
                this.appendLogMessage(logMessage)
                showPwaFlash(logMessage, "error")
                return
            } 

            logMessage = `【${modeLabel}・オフライン】${count}名を一括で出勤打刻しました。（${timeStr}）`
            showPwaFlash(logMessage, "success")
        }

        // Collect form data
        for (let [key, value] of formData.entries()) {
            if (payload[key]) {
                if (!Array.isArray(payload[key])) {
                    payload[key] = [payload[key]]
                }
                payload[key].push(value)
            } else {
                payload[key] = value
            }
        }
        
        // Capture the actual clock-in/out timestamp
        payload["offline_timestamp"] = new Date().toISOString()

        // Add to queue
        await addToQueue({
            type,
            payload
        })

        // Update status badge
        await this.updateStatusBadge()

        // Save log
        await saveLog(logMessage)

        // Render log
        this.appendLogMessage(logMessage)
    }

    appendLogMessage(message) {
        const empty = document.getElementById("record-empty")
        if (empty) empty.remove()

        const container = document.getElementById("record-log")
        if (!container) return

        const div = document.createElement("div")
        div.className = "record-item"
        div.dataset.alreadySaved = "true"
        div.textContent = message

        container.insertBefore(div, container.firstChild)
    }

    async validateIndividualStatus(type) {
        const modeLabel = "個人"

        const serverStatus = await getAttendanceStatus()
        const today = new Date().toISOString().slice(0, 10)

        const queue = await getAllQueue()
        const todayQueue = queue.filter(q => q.createdAt.slice(0, 10) === today)

            const hasOnlineClockIn = serverStatus?.date === today && serverStatus.showed_up_at
            const hasOnlineClockOut = serverStatus?.date === today && serverStatus.left_at
            const hasOfflineClockIn = todayQueue.some(q => q.type === "clock_in")
            const hasOfflineClockOut = todayQueue.some(q => q.type === "clock_out")

            const hasClockIn = hasOnlineClockIn || hasOfflineClockIn
            const hasClockOut = hasOnlineClockOut || hasOfflineClockOut


        if (type === "clock_in" && hasClockIn) {
            const offlineLabel = hasOfflineClockIn && !hasOnlineClockIn ? "・オフライン" : ""
            const logMessage = `【${modeLabel}${offlineLabel}】あなた さんはすでに出勤済みのため、打刻は行われませんでした。`
            await saveLog(logMessage)
            this.appendLogMessage(logMessage)
            showPwaFlash(logMessage, "error")
            return false
        }

        if (type === "clock_out") {
            if (!hasClockIn) {
                const logMessage = `【${modeLabel}】あなた 出勤登録を行っていません。`
                await saveLog(logMessage)
                this.appendLogMessage(logMessage)
                showPwaFlash(logMessage, "error")
                return false
            }
            if (hasClockOut) {
                const offlineLabel = hasOfflineClockOut && !hasOnlineClockOut ? "・オフライン" : ""
                const logMessage = `【${modeLabel}${offlineLabel}】あなた はすでに退勤済みのため、打刻は行われませんでした。`
                await saveLog(logMessage)
                this.appendLogMessage(logMessage)
                showPwaFlash(logMessage, "error")
                return false
            }
        }

        return true
    }

    async updateStatusBadge() {
        const status = await resolveOfflineStatus()
        renderBadge(status)
    }
}